import ReactDom from 'react-dom';
import App from './App';
import './index.css';

ReactDom.render(<App />, document.querySelector('#root'))